import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrls: ['./status-chip.component.scss'],
})
export class StatusChipComponent {
  @Input() statusColor: StatusChipColor = StatusChipColor.GREY;
  @Input() statusHoverMessage = '';
  @Input() statusMessage = '';
  @Input() statusMessageSubtitle = '';
  @Input() statusIcon: StatusChipIcon = StatusChipIcon.NONE;
  public statusChipColor = StatusChipColor;
  public statusChipIcon = StatusChipIcon;
}

export enum StatusChipColor {
  'BLUE' = 'BLUE',
  'BLUE_4' = 'BLUE_4',
  'GREEN' = 'GREEN',
  'GREY' = 'GREY',
  'RED' = 'RED',
  'YELLOW' = 'YELLOW',
  'WHITE' = 'WHITE',
}

export enum StatusChipIcon {
  'NONE',
  'LOCK',
  'INFO',
}
